<template>
    <v-card tile v-if="value != null && measureItem != null" outlined :height="height" style="position:relative" @click="$emit('click', value)">
        <!-- <v-card-text> -->
            <div id="bar" :style="barStyle" />
            <table style="position:absolute; width:100%; z-index:2">
                <tr>
                    <td style="text-align:center; font-size:small">{{value.time}}</td>
                </tr>
                <tr>
                    <td style="text-align:center; font-size:small; font-weight:bold">
                        {{value.value}}
                        <span style="font-size:xx-small">{{measureItem.body.unit}}</span>
                    </td>
                </tr>
            </table>
        <!-- </v-card-text> -->
    </v-card>
</template>

<script>
    export default {
        props: {
            measureItem: null,
            value: null,
            height: {
                type: Number,
                default: 48
            }
        },
        data: function () {
            return {                
            }
        },
        computed: {
            barStyle: function () {
                const r = (this.value.value - this.measureItem.body.min) / (this.measureItem.body.max - this.measureItem.body.min)
                // console.log(this.measureItem.body.max, this.measureItem.body.min, this.value.value, r)
                var style = {
                    position: "absolute",
                    width: "100%",
                    height: ((r * this.height) - 1) + "px",
                    top: (((1-r) * this.height) - 1) + "px",
                    "z-index": 0,
                    backgroundColor: "rgba(255,0,0,0.1)",
                }
                return style
            }
        }
    }
</script>

<style scoped>
    #bar {
        background: -webkit-repeating-linear-gradient(
            0deg,
            #ff000020,
            #ff000020 3px,
            #ffff0020 3px,
            #ffff0020 6px,
        );
        background: -moz-repeating-linear-gradient(
            0deg,
            #ff000020,
            #ff000020 3px,
            #ffff0020 3px,
            #ffff0020 6px,
        );
        /* background: repeating-linear-gradient(
            0deg,
            #ff000020,
            #ff000020 3px,
            #ffff0020 3px,
            #ffff0020 6px,
        ); */
        background: repeating-linear-gradient(
            0deg,
            rgba(255,200,0,0.1),
            rgba(255,200,0,0.1) 3px,
            rgba(255,255,0,0.1) 3px,
            rgba(255,255,0,0.1) 6px,
        );
        /* background-image: linear-gradient(
            0deg,
            rgba(255,255,0,0.1),
            rgba(255,0,0,0.1),
        ); */
    }
</style>